var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { themeLss } from "../../lss";
import styled from "../../styled";
/**
 * It should be used whenever we output Text to maintain consistency.
 *
 * We also provide built-in variations for different heading sizes.
 */
export var Text = styled.span(themeLss({ textScale: 'content' }));
var BaseHeading = styled.span(themeLss({ m: 0 }));
export var H1 = styled(BaseHeading).attrs({ as: 'h1' })(function (_a) {
    var theme = _a.theme;
    return theme.typography.heading1;
});
export var H2 = styled(BaseHeading).attrs({ as: 'h2' })(function (_a) {
    var theme = _a.theme;
    return theme.typography.heading2;
});
export var H3 = styled(BaseHeading).attrs({ as: 'h3' })(function (_a) {
    var theme = _a.theme;
    return theme.typography.heading3;
});
export var H4 = styled(BaseHeading).attrs({ as: 'h4' })(function (_a) {
    var theme = _a.theme;
    return theme.typography.heading4;
});
export var H5 = styled(BaseHeading).attrs({ as: 'h5' })(function (_a) {
    var theme = _a.theme;
    return theme.typography.heading5;
});
export var H6 = styled(BaseHeading).attrs({ as: 'h6' })(function (_a) {
    var theme = _a.theme;
    return theme.typography.heading6;
});
/**
 * Renders the children when it's a string
 * otherwise render it as Text with the provided props
 */
export var TextOrNode = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    if (typeof children === 'string') {
        return React.createElement(Text, __assign({}, otherProps), children);
    }
    // had to use a fragment to make TS interpret the null, undefined, {} and number children
    return React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=Text.js.map